export { DispensaryCardController as DispensaryCard } from './dispensary-card-controller';
